<div *ngIf="!showContactPage && !isShowHangOnLoading">
  <div class="bl-text-align--center">
    <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" viewBox="0 0 49 48" fill="none">
      <path
        d="M40.5 8H8.5C6.8457 8 5.5 9.34571 5.5 11V35C5.5 35.5522 5.9473 36 6.5 36H42.5C43.0527 36 43.5 35.5522 43.5 35V11C43.5 9.34571 42.1543 8 40.5 8Z"
        fill="#444444"
      />
      <path
        d="M1.5 32.9998V34.9998C1.5 37.7566 3.7432 39.9998 6.5 39.9998H42.5C45.2568 39.9998 47.5 37.7566 47.5 34.9998V32.9998H1.5Z"
        fill="#A5B0B8"
      />
      <path d="M40.5 11H8.5V30H40.5V11Z" fill="white" />
      <path
        d="M27.5 35.9998H21.5C20.3955 35.9998 19.5 35.1043 19.5 33.9998V32.9998H29.5V33.9998C29.5 35.1043 28.6045 35.9998 27.5 35.9998Z"
        fill="#1C2B36"
      />
      <path
        d="M24.5 13C20.634 13 17.5 16.134 17.5 20C17.5 23.866 20.634 27 24.5 27C28.366 27 31.5 23.866 31.5 20H24.5V13Z"
        fill="#E86C60"
      />
      <path d="M24.5 13V20H31.5C31.5 16.134 28.366 13 24.5 13Z" fill="#EFD358" />
    </svg>
  </div>
  <h2 class="bl-font-size--28 bl-margin-bottom--16 bl-font-weight--900 bl-font-color--black bl-text-align--center">Accounts & Services</h2>
  <p *ngIf="isPageSubmitted && !isAnyShareSelected" class="bl-font-size--16 bl-font-color--error bl-font-weight--800">
    {{ 'accountsAndService/noShareSelected' | dictionary }}
  </p>
  <ng-container *ngIf="getIncludedProducts().shares.length > 0 || getOptionalProducts().shares.length > 0">
    <ecp-oao-included-account
      [includedProductsAndServices]="getIncludedProducts()"
      (enableContinueButton)="enableContinueButton($event)"
      [field]="field"
      [optionalProductsAndServices]="getOptionalProducts()"
      [allProducts]="products"
      [coApplicantProducts]="getCoApplicantIncludedProducts()"
      [allServices]="membershipServices"
      [shareOptions]="shareOptions"
      >
    </ecp-oao-included-account>
  </ng-container>
  <div
    id="additional-shares"
    class="bl-block-module bl-padding--16 bl-padding-md--24"
    *ngIf="groupedProducts && groupedProducts.length > 0"
    [attr.data-automation-id]="'additional-options-services-card'"
  >
    <h2 class="bl-font-size--18 bl-margin-bottom--16 bl-font-weight--900">Additional account options</h2>
    <ng-container *ngFor="let product of groupedProducts">
      <ng-container *ngIf="product.productType == 'checking' || product.productType == 'saving' || product.productType == 'moneymarket'">
        <ecp-oao-checking-and-saving-account
          (enableContinueButton)="enableContinueButton($event)"
          [mainAccount]="getProductsByType(product.productType)"
          [allProducts]="products"
          [coApplicantProducts]="getCoApplicantProductsByType(product.productType)"
          [isInitialLoading]="isInitialLoading"
        >
        </ecp-oao-checking-and-saving-account>
      </ng-container>
      <ng-container *ngIf="product.productType == 'retirement'">
        <ecp-oao-retirement-account
          (enableContinueButton)="enableContinueButton($event)"
          [retirementAccount]="getProductsByType(product.productType)"
          [allProducts]="products"
          [coApplicantProducts]="getCoApplicantProductsByType(product.productType)"
          [isInitialLoading]="isInitialLoading"
        >
        </ecp-oao-retirement-account>
      </ng-container>
      <ng-container *ngIf="product.productType == 'other'">
        <ecp-oao-other-account
          (enableContinueButton)="enableContinueButton($event)"
          [mainAccount]="getProductsByType(product.productType)"
          [allProducts]="products"
          [coApplicantProducts]="getCoApplicantProductsByType(product.productType)"
          [isInitialLoading]="isInitialLoading"
        >
        </ecp-oao-other-account>
      </ng-container>
      <ng-container *ngIf="product.productType == 'sharecertificates' || product.productType == 'retiresharecertificates'">
        <ecp-oao-share-certificates-account
          (enableContinueButton)="enableContinueButton($event)"
          [field]="field"
          [coApplicantProducts]="getCoApplicantProductsByType(product.productType)"
          [mainAccount]="getProductsByType(product.productType)"
          [allProducts]="products"
          [isInitialLoading]="isInitialLoading"
          [shareOptions]="shareOptions"
        >
        </ecp-oao-share-certificates-account>
      </ng-container>
    </ng-container>
    <p
      class="bl-margin-top--16 bl-text-align--center bl-font-color--primary bl-font-size--16 bl-font-weight--800 bl-cursor--pointer"
      *ngIf="showmore && !showFullList"
      (click)="showAllProduct()"
    >
      {{ showmore }}
    </p>
  </div>
  <div
    class="bl-block-module bl-padding--16 bl-padding-md--24 bl-margin-top--24"
    *ngIf="groupedServices && groupedServices.length > 0"
    [attr.data-automation-id]="'additional-addon-services-card'"
  >
    <h2 class="bl-font-size--18 bl-margin-bottom--16 bl-font-weight--900">Additional add-on services</h2>
    <ng-container *ngFor="let service of groupedServices">
      <ecp-oao-other-account-member-service
        [mainService]="getServicesByType(service.productType)"
        [allServices]="membershipServices"
        [coApplicantServices]="getCoApplicantMembershipServiceByType(service.productType)"
        [isInitialLoading]="isInitialLoading"
      >
      </ecp-oao-other-account-member-service>
    </ng-container>
  </div>
</div>
<ecp-lender-contact-blocks *ngIf="showContactPage && !isShowHangOnLoading" [lenderData]="lenderConfig"> </ecp-lender-contact-blocks>

<ng-container *ngIf="dynamicPageHeader()"></ng-container>

<ea-orbit-loader [loading]="isShowHangOnLoading"></ea-orbit-loader>
